<template>
  <div>
    <div v-if="$config.show_low_balance_notification" class="low-balance-banner">{{ $t('core.dashboard.low-balance') }}</div>
    <div class="theme-container">
      <div class="content-wrapper">
        <header-component key="header" class="header--fixed">
          <template slot="position-left">
            <div :class="{ sidebar: true, 'mr-auto': !worksheet_id }">
              <logo />
            </div>
            <div class="mr-auto"></div>
            <!-- <worksheet-editable-name v-if="worksheet_id" :id="worksheet_id" class="mr-auto" /> -->
            <back-button class="header__item" />
          </template>
        </header-component>
        <app-view class="page-content page-content--fixed-header" />
      </div>
    </div>
  </div>
</template>

<script>
  import HeaderComponent from '@shared/components/layout-default/layout-default-header';
  import Logo from '@shared/components/layout-default/layout-default-logo';
  import BackButton from './header/back-button';
  // import WorksheetEditableName from './header/worksheet-name';

  export default {
    components: {
      HeaderComponent,
      Logo,
      BackButton
      // WorksheetEditableName
    },

    computed: {
      worksheet_id: function () {
        if (this.$route.name === 'autoinformer.worksheet.edit') {
          return this.$route.params.id;
        }
        return null;
      }
    }
  };
</script>

<style lang="scss">
  .theme-container .content-wrapper {
    .header {
      width: 100%;
      &--fixed {
        position: fixed;
        z-index: 5;
      }
    }

    .page-content {
      &--fixed-header {
        margin-top: 70px;
        padding: 0;
        min-height: calc(100% - 70px - 20px);
      }
    }
  }
</style>
